/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./Skeleton.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-skeleton");
exports.SkeletonRow = function SkeletonRow(_a) {
    var className = _a.className, bold = _a.bold, incompleteRow = _a.incompleteRow, props = tslib_1.__rest(_a, ["className", "bold", "incompleteRow"]);
    return (React.createElement("div", { className: classnames(moduleClassName("row"), !!bold && moduleClassName("bold"), !!incompleteRow && moduleClassName("incomplete"), className) }));
};
exports.SkeletonListItem = function SkeletonListItem(_a) {
    var className = _a.className, props = tslib_1.__rest(_a, ["className"]);
    return (React.createElement("div", { className: classnames(moduleClassName("listItem"), className) },
        React.createElement("div", { className: moduleClassName("listIcon") }),
        React.createElement(exports.SkeletonRow, { className: classnames(moduleClassName("listText"), className) })));
};
exports.SkeletonTitle = function SkeletonTitle(_a) {
    var className = _a.className, props = tslib_1.__rest(_a, ["className"]);
    return (React.createElement(exports.SkeletonRow, { bold: true, className: classnames(moduleClassName("title"), className) }));
};
exports.SkeletonShortTitle = function SkeletonShortTitle(_a) {
    var className = _a.className, props = tslib_1.__rest(_a, ["className"]);
    return (React.createElement(exports.SkeletonRow, { bold: true, className: classnames(moduleClassName("short"), className) }));
};
exports.SkeletonText = function SkeletonText(_a) {
    var className = _a.className, numberOfRows = _a.numberOfRows, props = tslib_1.__rest(_a, ["className", "numberOfRows"]);
    var rows = [];
    for (var index = 0; index < numberOfRows; index++) {
        rows.push(React.createElement(exports.SkeletonRow, { key: index, incompleteRow: index === numberOfRows - 1 }));
    }
    return (React.createElement("div", { className: classnames(moduleClassName("text"), className) }, rows));
};
exports.SkeletonList = function SkeletonList(_a) {
    var className = _a.className, numberOfRows = _a.numberOfRows, props = tslib_1.__rest(_a, ["className", "numberOfRows"]);
    var rows = [];
    for (var index = 0; index < numberOfRows; index++) {
        rows.push(React.createElement(exports.SkeletonListItem, null));
    }
    return (React.createElement("div", { className: classnames(moduleClassName("list"), className) }, rows));
};
exports.SkeletonNavigationHeader = function SkeletonNavigationHeader(_a) {
    var className = _a.className, props = tslib_1.__rest(_a, ["className"]);
    return (React.createElement("div", { className: classnames(moduleClassName("navigtionHeader"), className) },
        React.createElement(exports.SkeletonRow, null),
        React.createElement(exports.SkeletonShortTitle, null)));
};
exports.SkeletonPanel = function SkeletonPanel(_a) {
    var className = _a.className, panelTitle = _a.panelTitle, props = tslib_1.__rest(_a, ["className", "panelTitle"]);
    return (React.createElement("div", { className: classnames(moduleClassName("panel"), className) },
        React.createElement("div", { className: moduleClassName("panelHeader") }, !!panelTitle ? panelTitle : React.createElement(exports.SkeletonTitle, null)),
        React.createElement("div", { className: moduleClassName("panelContent") },
            React.createElement(exports.SkeletonText, { numberOfRows: 4 }))));
};